import { getStorageItem, setStorageItem, WebStorageType } from "../../../../common-deprecated/utils/storageUtils";
import type { CommonSettingsType } from "../../../../common-deprecated/settings/fetchCommonSettings";

// ----------------------------------------------------------------------
// Helper types and consts
// ----------------------------------------------------------------------
const LOCAL_STORAGE_ID = "com.toyota.tme.t1.aphcarconfig";

type CarConfigLocalStorageParams = {
    country: string;
    language: string;
};

type CarConfigLocalStorageItemType = {
    introAnimationHasPlayed?: boolean;
    external?: {
        unfinishedConfigurations: {
            tyCode: string;
            completed: boolean;
            section: string;
        };
    };
};

// ------------------------------------------------------------------------
// Storage fns
// ------------------------------------------------------------------------
export const setCarConfigLocalStorage = (
    params: CarConfigLocalStorageParams,
    storageItems: CarConfigLocalStorageItemType,
): void => {
    setStorageItem({ ...params, storageId: LOCAL_STORAGE_ID }, storageItems, WebStorageType.local);
};

export const getCarConfigLocalStorage = (params: CarConfigLocalStorageParams): CarConfigLocalStorageItemType | null => {
    return getStorageItem({ ...params, storageId: LOCAL_STORAGE_ID }, WebStorageType.local);
};

// ------------------------------------------------------------------------
// Intro animation
// ------------------------------------------------------------------------
export const getIntroAnimationHasPlayed = (params: CarConfigLocalStorageParams): boolean => {
    return getCarConfigLocalStorage(params)?.introAnimationHasPlayed || false;
};

export const setIntroAnimationHasPlayed = (params: CarConfigLocalStorageParams): void => {
    setCarConfigLocalStorage(params, { introAnimationHasPlayed: true });
};

// ------------------------------------------------------------------------
// Unfinished configurations
// ------------------------------------------------------------------------
export const setUnfinishedConfiguration = (
    params: CarConfigLocalStorageParams,
    tyCode: string,
    activeSection: string,
): void => {
    setCarConfigLocalStorage(params, {
        external: { unfinishedConfigurations: { tyCode, completed: false, section: activeSection } },
    });
};

export const getUnfinishedConfiguration = (
    params: CarConfigLocalStorageParams,
): { tyCode: string; completed: boolean; section: string } | undefined => {
    return getCarConfigLocalStorage(params)?.external?.unfinishedConfigurations;
};

export const completeUnfinishedConfiguration = (params: CarConfigLocalStorageParams): void => {
    const currentConfig = getUnfinishedConfiguration(params);

    if (currentConfig) {
        setCarConfigLocalStorage(params, {
            external: { unfinishedConfigurations: { ...currentConfig, completed: true } },
        });
    }
};

// ------------------------------------------------------------------------
// Storage fns
// ------------------------------------------------------------------------
export const getLocalStorageParams = ({
    commonSettings,
}: {
    commonSettings: CommonSettingsType;
}): CarConfigLocalStorageParams => ({
    country: commonSettings.country,
    language: commonSettings.language,
});
